import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as loginApi } from '../api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();

  console.log("LOGIN BUTTON CLICKED");
  console.log("API URL:", process.env.REACT_APP_API_URL);
  console.log("EMAIL:", email);

  setError('');
  setLoading(true);

  try {
    const res = await loginApi(email, password);
      login(res.data.token, res.data.user);
      navigate('/pipeline');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'#2C2C2A', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' }}>
      <div style={{ width:'100%', maxWidth:'380px' }}>
        <div style={{ textAlign:'center', marginBottom:'32px' }}>
          <div style={{ fontSize:'24px', fontWeight:'700', color:'#fff', letterSpacing:'-0.03em' }}>
            Aranyaka <span style={{ color:'#9FE1CB' }}>Estates</span>
          </div>
          <div style={{ fontSize:'13px', color:'rgba(255,255,255,0.4)', marginTop:'6px' }}>
            Sales CRM — sign in to continue
          </div>
        </div>
        <form onSubmit={handleSubmit} style={{ background:'#fff', borderRadius:'12px', padding:'28px' }}>
          {error && (
            <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'10px 14px', borderRadius:'8px', fontSize:'13px', marginBottom:'16px' }}>
              {error}
            </div>
          )}
          <div className="form-field">
            <label className="form-label">Email address</label>
            <input className="form-input" type="email" value={email}
              onChange={e => setEmail(e.target.value)} placeholder="you@aranyakaestates.com" required />
          </div>
          <div className="form-field">
            <label className="form-label">Password</label>
            <input className="form-input" type="password" value={password}
              onChange={e => setPassword(e.target.value)} placeholder="Enter your password" required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'10px', marginTop:'4px' }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
          <p style={{ fontSize:'11px', color:'#888', textAlign:'center', marginTop:'16px' }}>
            Contact your Sales Head if you need access.
          </p>
        </form>
      </div>
    </div>
  );
}
